import { createFileRoute } from '@tanstack/react-router';
import { AdminCoachConversationsView } from '@/components/admin/AdminCoachConversationsView';

interface CoachSearch {
  readonly conversation?: string;
}

export const Route = createFileRoute('/_authed/admin/coach/')({
  validateSearch: (raw: Record<string, unknown>): CoachSearch =>
    typeof raw.conversation === 'string' && raw.conversation.length > 0
      ? { conversation: raw.conversation }
      : {},
  component: CoachConversationsPage,
});

function CoachConversationsPage() {
  const { conversation } = Route.useSearch();
  return <AdminCoachConversationsView openConversationId={conversation ?? null} />;
}
